import { createFileRoute } from '@tanstack/react-router';

import { PlatformTeamPage } from '../modules/users/ui/pages/PlatformTeamPage';

export const Route = createFileRoute('/_authenticated/super-admin/team')({
  component: PlatformTeamPage,
  staticData: {
    breadcrumb: ['Platform', 'Team'],
  },
});
